import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalsToCampaignTable } from "./TerminalsToCampaignTable";

export const TerminalToCampaignsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
                const id = getFieldValue("id");

                return (
                    id && (
                        <Form.Item key={`${field.name}FormItem`} name={field.name}>
                            <TerminalsToCampaignTable key={field.name} readOnly={readOnly} campaignId={id} />
                        </Form.Item>
                    )
                );
            }}
        </Form.Item>
    );
};
